import { ekDomain } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { COMMON_TYPE } from '@/types/enums';
import { isPathEk } from '@/utils/routes';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TopPriceImg from '@/assets/images/bg-top-price.png';
import './style.scss';
import ParallaxImage from '@/components/general/ParallaxImage';
import { URL_CONFIG } from '@/configs/environment';
import PriceList from './components/price';
import OptionList from './components/option';
import OtherPriceList from './components/other-option';
import OtherSettingList from './components/other-setting';
import BannerLayout from '@/components/layout/banner-layout';

export default observer(function PricePage() {
    // hook
    const { pathname, hash } = useLocation();

    // state
    const contentRef = useRef<HTMLDivElement | null>(null);

    // const
    const isEk = isPathEk(pathname);

    // store
    const {
        capacitieStore: { getCapacitieList, capacitieList },
        priceStore: { getPriceListEnduser, priceEUList },
        optionStore: { getOptionsEnduser, optionsForOrder },
        generalStore: { otherSetting, getCancelSetting, getOtherSetting },
        uiStore: { setObservable }
    } = useStore();

    // state
    const [dataLoaded, setDataLoaded] = useState(false);

    // lifecycle
    useEffect(() => {
        fetchData();
        // .then(() => setDataLoaded(true)) // khi tất cả xong → bật flag
        // .catch(console.error);

        return () => {
            // setOtherOptions([...OtherOption]);
            setObservable('contentTop', null);
        };
    }, []);

    useEffect(() => {
        if (!dataLoaded || !hash) return;
        const id = hash.substring(1);
        const el = document.getElementById(id);
        if (el) {
            const offset = 80; // khoảng cách muốn chừa trên cùng
            const top = el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }, [dataLoaded, hash]);

    useEffect(() => {
        if (contentRef.current) {
            const updatePosition = () => {
                if (contentRef?.current) {
                    const top = contentRef?.current?.getBoundingClientRect().top + window.scrollY;
                    setObservable('contentTop', top);
                }
            };

            window.addEventListener('scroll', updatePosition);
            window.addEventListener('resize', updatePosition);

            updatePosition();

            return () => {
                window.removeEventListener('scroll', updatePosition);
                window.removeEventListener('resize', updatePosition);
            };
        }
    }, [contentRef.current]);

    useEffect(() => {
        if (capacitieList.length > 0 && priceEUList.length > 0 &&
            Object.keys(optionsForOrder).length > 0 && Object.keys(otherSetting).length > 0) {
            setDataLoaded(true);
        }
    }, [capacitieList, priceEUList, optionsForOrder, otherSetting]);

    // function

    const fetchData = async () => {
        const type = isEk ? COMMON_TYPE.EK : COMMON_TYPE.GAS;

        getCancelSetting();
        getCapacitieList({ type, sortKey: 'id', sortDir: 'asc' });
        getPriceListEnduser({ type });
        getOptionsEnduser({ type });
        getOtherSetting();
    };

    return (
        <div className='price-list-enduser point-900:pt-0 pt-5 pb-[min(120px,12vw)]'>
            <div className='h-fit overflow-hidden'>
                <BannerLayout url={`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${isEk ? ekDomain : ''}`} hasSubImg title='料金表' subTitle='料金表' />
                <div className='w-full point-900:aspect-[1/0.1708] aspect-[1/0.33] relative overflow-hidden'>
                    <picture className='w-full absolute top-1/2 left-0 -translate-y-1/2'>
                        <source
                            srcSet={TopPriceImg}
                            type='image/webp'
                        />
                        <ParallaxImage
                            src={TopPriceImg}
                            alt=''
                            className='w-full max-w-full h-full'
                        />
                    </picture>

                </div>
            </div>
            <div ref={contentRef} className='mt-[min(120px,12vw)]'>
                <div className='wrapper-inner flex flex-col gap-[min(60px,10vw)]'>
                    <PriceList />
                    <OptionList />
                    <OtherSettingList />
                    <OtherPriceList />
                </div>
            </div>
        </div>
    );
});
